var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canListSales)?_c('v-autocomplete',{attrs:{"items":_vm.sales,"label":_vm.label,"clearable":"","dense":"","item-text":"name","item-value":"id","outlined":""},model:{value:(_vm.selectedSale),callback:function ($$v) {_vm.selectedSale=$$v},expression:"selectedSale"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }